import * as ttq from "react-dom/test-utils";
import { produce } from "immer";

import { LOCAL_STORAGE_KEYS } from "shared/constants/storageKeys";
import { DEFAULT_MODE_WIZARD } from "shared/constants/wizard";

import { WizardStep } from "shared/hooks/useWizard";

import {
  postWizardAbout,
  postWizardFinish,
  postWizardPrefences,
  postWizardStart,
} from "shared/services/wizard";

import { escapeText, setLocalStorageData } from "./view";

/**
 * Escape symbols in text fields from profile data
 *
 */

export const escapeProfile = (state) => {
  const escapedState = {
    first_name: escapeText(state.first_name),
    bio: escapeText(state.bio),
    occupation: escapeText(state.occupation),
  };

  return Object.assign({}, state, escapedState);
};

/**
 * Twitter conversation track
 *
 * @param {Number} [iteration] Iteration
 */
export const twqConversionTrack = (iteration) => {
  if (!import.meta.env.twqInitKey || iteration > 1) {
    return;
  }

  if (typeof twq !== "function") {
    if (!iteration) {
      iteration = 0;
    }

    setTimeout(() => {
      twqConversionTrack(++iteration);
    }, 5000);
  }
};

/**
 * TikTok registrationS tracking
 * @param {Number} iteration Execute iteration
 */
export const tiktokRegistrationConversion = (iteration = 0) => {
  try {
    if (typeof ttq === "undefined") {
      if (iteration >= 8) {
        return;
      }

      setTimeout(() => {
        tiktokRegistrationConversion(++iteration);
      }, 1000);
      // return;
    }

    // If for different brands we will need
    // different keys than move key to config file

    // ttq.load(import.meta.env.tiktokKey ?? "C525RP800UN7QUNERE9G");
    // ttq.page();
  } catch (e) {
    console.error(e.toString());
  }
};

/**
 * SnapChat registration tracking
 *
 * @param {Number} iteration Execute iteration
 */
export function snapchatRegistrationConversion(iteration = 0) {
  try {
    if (typeof snaptr !== "function") {
      if (iteration >= 8) {
        return;
      }

      setTimeout(() => {
        snapchatRegistrationConversion(++iteration);
      }, 1000);
      // return;
    }

    // snaptr("track", "PAGE_VIEW");
    // snaptr("track", "SIGN_UP");
  } catch (e) {
    console.error(e.toString());
  }
}

/**
 *Parse date of birthday from string
 * @param {string} dateString
 */
export function parseDateOfBirth(dateString) {
  // Split the date string into its components
  const [year, month, day] = dateString.split("-").map(Number);

  // Create an object representing the date
  const dateOfBirth = {
    year,
    month,
    day,
  };

  // Return the date object
  return dateOfBirth;
}

export const postWizardData = async (answers, pathname) => {
  if (pathname === WizardStep.WelcomeStep1) {
    await postWizardStart({
      step_block: 1,
    });
  }
  if (pathname === WizardStep.DateAge) {
    await postWizardPrefences({
      step: "age",
      step_block: 1,
      ...answers.age,
    });
  }
  if (pathname === WizardStep.JoinReason) {
    await postWizardPrefences({
      join_reasons: answers.join_reasons,
      step: "join_reasons",
      step_block: 1,
    });
  }
  if (pathname === WizardStep.DateBodyType) {
    await postWizardPrefences({
      body_type: answers.d_body_type.map((e) => e.toString()),
      step: "body_type",
      step_block: 1,
    });
  }
  if (pathname === WizardStep.WelcomeStep2) {
    await postWizardStart({
      step_block: 2,
    });
  }
  if (pathname === WizardStep.Bio) {
    await postWizardAbout({
      bio: answers.bio,
      step: "bio",
      step_block: 2,
    });
  }
  if (pathname === WizardStep.BodyType) {
    await postWizardAbout({
      body_type: answers.body_type[0].toString(),
      step: "body_type",
      step_block: 2,
    });
  }
  if (pathname === WizardStep.Location) {
    await postWizardAbout({
      ...answers.location,
      step: "location",
      step_block: 2,
    });
  }
  if (pathname === WizardStep.MaritalStatus) {
    await postWizardAbout({
      marital_status: answers.marital_status[0].toString(),
      step: "marital_status",
      step_block: 2,
    });
  }
  if (pathname === WizardStep.Occupation) {
    await postWizardAbout({
      occupation: answers.occupation,
      step: "occupation",
      step_block: 2,
    });
  }
  if (pathname === WizardStep.Interests) {
    setLocalStorageData(LOCAL_STORAGE_KEYS.KEY_INTERESTS, answers.interests);

    await postWizardAbout({
      interests: answers.interests,
      step: "interests",
      step_block: 2,
    });
  }
  if (pathname === WizardStep.WelcomeStep3) {
    await postWizardStart({
      step_block: 3,
    });
  }
  if (pathname === WizardStep.FinishStep) {
    await postWizardFinish();
  }
};

export const redirectToCurrentStep = (wizard, navigate) => {
  if (!wizard?.data?.isFetched) return;

  if (
    !wizard?.data?.reg_funnel_step &&
    !wizard[WizardStep.WelcomeStep1]?.shouldBeSkipped
  ) {
    navigate(WizardStep.WelcomeStep1);
    return;
  }

  if (wizard[WizardStep.WelcomeStep1]?.shouldBeSkipped) {
    navigate(wizard[WizardStep.WelcomeStep1]?.nextStep);
    return;
  }

  const currentStep = wizard?.[wizard?.data?.reg_funnel_step];

  if (!currentStep?.nextStep) {
    navigate(wizard?.data?.reg_funnel_step);
    return;
  }

  if (
    wizard?.data?.reg_funnel_step === WizardStep.BodyType &&
    wizard?.data?.reg_funnel_block === 1 &&
    wizard[WizardStep.DateBodyType]?.nextStep
  ) {
    navigate(wizard[WizardStep.DateBodyType].nextStep);
  } else {
    navigate(currentStep.nextStep);
  }
};

export const checkIsContinueAvaliable = (
  isNotProvide = false,
  step = {},
  answers = {},
  stepName,
  isPhoto = false
) => {
  switch (true) {
    case stepName === WizardStep.AddPhoto:
      return isPhoto;
    case stepName === WizardStep.Occupation:
      return (
        answers?.occupation?.length <= 255 && answers?.occupation?.length > 0
      );
    case stepName === WizardStep.Interests:
      return answers?.interests?.length >= 3;
    case stepName === WizardStep.Location:
      return (
        answers?.[WizardStep.Location]?.residence_city &&
        answers?.[WizardStep.Location]?.residence_city
      );
    case isNotProvide:
      return true;
    case "criteria" in step:
      return (
        Object.keys(answers?.[stepName] ?? {})?.length ===
        Object.keys(step?.criteria ?? {}).length
      );
    case "answers" in step:
      return Object.entries(answers?.[stepName] ?? {})?.length > 0;
    case "fieldArea" in step:
      return answers?.[stepName]?.length > 0;

    default:
      return false;
  }
};

export const setStepperState = (initialStepper, block, mode, reduced) => {
  return produce(initialStepper, (wizard) => {
    const currentStepper =
      mode === DEFAULT_MODE_WIZARD && !reduced
        ? {
            1: {
              isCompleted: false,
              isActive: true,
              number: 1,
              title: "About your date",
            },
            2: {
              isCompleted: false,
              isActive: false,
              number: 2,
              title: "About yourself",
            },
            3: {
              isCompleted: false,
              isActive: false,
              number: 3,
              title: "Add Photo",
            },
          }
        : mode !== DEFAULT_MODE_WIZARD
          ? {
              1: {
                isCompleted: false,
                isActive: false,
                number: 1,
              },
              2: {
                isCompleted: false,
                isActive: false,
                number: 2,
              },
              3: {
                isCompleted: false,
                isActive: false,
                number: 3,
              },
              4: {
                isCompleted: false,
                isActive: false,
                number: 4,
              },
              5: {
                isCompleted: false,
                isActive: false,
                number: 5,
              },
            }
          : {
              1: {
                isCompleted: false,
                isActive: false,
                number: 1,
              },
              2: {
                isCompleted: false,
                isActive: false,
                number: 2,
              },
            };

    Object.keys(currentStepper).forEach((key) => {
      const step = currentStepper[key];
      const index = parseInt(key, 10);

      if (index < block) {
        step.isCompleted = true;
        step.isActive = false;
      } else if (index === block) {
        step.isActive = true;
        step.isCompleted = false;
      } else {
        step.isActive = false;
        step.isCompleted = false;
      }
    });
    wizard.stepper = currentStepper;
  });
};
